import CardCategories from './CardCategories';

export default CardCategories;
